import React, { useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Typography,
  Button,
  Grid,
  Box,
  TextField,
  Divider,
} from '@material-ui/core'
import { CompanyLogo, CheckoutDialog } from 'componentsCheckout'

const Settings = ({
  changeInput,
  partnerGroup = '',
  sellerData = '',
  components,
}) => {
  const [componentsEdit, setComponentsEdit] = useState(components)
  const { control, handleSubmit } = useForm({
    defaultValues: {
      urlImage: componentsEdit?.urlImage || '',
    },
  })

  const onSubmit = (data) => {
    const updatedInputs = componentsEdit?.settings?.inputs.map(
      (input, index) => ({
        ...input,
        labelName: data[`labelname${input.id}`] || input?.labelName || '',
        field: {
          ...input.field,
          placeholder:
            data[`placeholder${input.id}`] || input?.field?.placeholder || '',
        },
        width: [
          data[`widthXs${input.id}`] || input?.width[0] || '', // Definindo fallback para xs
          data[`widthSm${input.id}`] || input?.width[1] || '', // Definindo fallback para sm
          data[`widthMd${input.id}`] || input?.width[2] || '', // Definindo fallback para md
          data[`widthLg${input.id}`] || input?.width[3] || '', // Definindo fallback para lg
        ],
      }),
    )

    const updatedComponentsEdit = {
      ...componentsEdit,
      urlImage: data.urlImage || componentsEdit?.urlImage || '',
      settings: {
        ...componentsEdit.settings,
        inputs: updatedInputs,
      },
    }

    setComponentsEdit(updatedComponentsEdit)
    // changeInput(updatedComponentsEdit)
  }

  const handleSaveButtonClick = () => {
    changeInput(componentsEdit)
  }

  return (
    <Box mb={10} style={{ width: '300px' }}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Box style={{ marginBottom: '20px' }}>
            <Typography color="textPrimary" variant="h6">
              Configurações
            </Typography>
            <Typography color="textPrimary" variant="body2">
              Defina os padrões de seu checkout
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography color="textPrimary" variant="body1">
            Logo
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Box
            style={{
              width: '160px',
              minHeight: '46px',
              backgroundColor: '#ecf6ff',
              marginBottom: '20px',
            }}
          >
            <CompanyLogo
              partnerGroup={partnerGroup}
              sellerData={sellerData}
              urlImage={componentsEdit?.urlImage}
            />
          </Box>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box mb={10}>
              <Controller
                name="urlImage"
                control={control}
                defaultValue={componentsEdit?.urlImage}
                as={
                  <TextField
                    type="text"
                    label="URL da imagem"
                    variant="outlined"
                    size="small"
                  />
                }
              />
            </Box>
            <Button variant="contained" color="primary" type="submit">
              Salvar
            </Button>
          </form>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Box mt={12}>
            <Typography color="textPrimary" variant="h6">
              Formulário
            </Typography>
            <CheckoutDialog title="Configurações do formulário">
              <form onSubmit={handleSubmit(onSubmit)}>
                {componentsEdit?.settings?.inputs?.map((input, index) => (
                  <Box pt={16} key={index}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Controller
                          name={`labelname${input.id}`}
                          control={control}
                          defaultValue={input?.labelName}
                          as={
                            <TextField
                              size="small"
                              label="Nome da label"
                              variant="outlined"
                            />
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Controller
                          name={`placeholder${input.id}`}
                          control={control}
                          defaultValue={input?.field?.placeholder}
                          as={
                            <TextField
                              size="small"
                              label="Placeholder"
                              variant="outlined"
                            />
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={2}>
                        <Controller
                          name={`widthXs${input.id}`}
                          control={control}
                          defaultValue={input?.width[0]}
                          as={
                            <TextField
                              size="small"
                              label="xs"
                              variant="outlined"
                            />
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={2}>
                        <Controller
                          name={`widthSm${input.id}`}
                          control={control}
                          defaultValue={input?.width[1]}
                          as={
                            <TextField
                              size="small"
                              label="sm"
                              variant="outlined"
                            />
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={2}>
                        <Controller
                          name={`widthMd${input.id}`}
                          control={control}
                          defaultValue={input?.width[2]}
                          as={
                            <TextField
                              size="small"
                              label="md"
                              variant="outlined"
                            />
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={2}>
                        <Controller
                          name={`widthLg${input.id}`}
                          control={control}
                          defaultValue={input?.width[3]}
                          as={
                            <TextField
                              size="small"
                              label="lg"
                              variant="outlined"
                            />
                          }
                        />
                      </Grid>
                    </Grid>
                    <Box mb={8} mt={8}>
                      <Divider />
                    </Box>
                  </Box>
                ))}
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ width: '100%' }}
                >
                  Salvar
                </Button>
              </form>
            </CheckoutDialog>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveButtonClick}
            style={{ width: '100%', marginTop: '20px' }}
          >
            Aplicar
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Settings
